export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-axis/src/array.js
// module id = JZkn
// module chunks = 0